Drupal.behaviors.articleScrollbar = {
    attach() {

        var article = document.getElementsByTagName('article')[0];
        var progressBar = document.getElementById("progress-bar");
        var articleBottom = document.querySelector('footer[data-da-event*="Artikelende"]');

        if (article && progressBar && articleBottom) {
            var headerElem = document.querySelector('header');
            var headerHeight = headerElem ? headerElem.clientHeight : 56;
            var navElem = document.querySelector('.track_servicenav');
            var navHeight = navElem ? navElem.clientHeight : 0;

            window.onscroll = function () {
                var winScroll = document.body.scrollTop || document.documentElement.scrollTop;

                var articleFooterHeight = 0;

                if (articleBottom) {
                    articleFooterHeight = articleBottom.clientHeight;
                }

                //add height of article header and nav
                var templateHeight = headerHeight + navHeight;

                //calculate height of scrollable area - article footer height + 40px for article header negative margin - height of client
                var height = (article.clientHeight + templateHeight - articleFooterHeight + 40) - document.documentElement.clientHeight;

                var scrolled = (winScroll / height) * 100;
                progressBar.style.width = scrolled + "%";
            };
        }
    },
};